import workerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

/**
 * Carga MapLibre (chunk propio) y le indica la URL de su web worker.
 * MapLibre 6 busca por defecto `./maplibre-gl-worker.mjs` junto a su propio
 * fichero, que tras el build de Vite no existe: sin esto el mapa se inicializa
 * pero nunca procesa capas (ni tierra, ni pines). Vite empaqueta el worker
 * (con sus imports) en un fichero aparte con `?worker&url`.
 */
export async function loadMaplibre() {
  const [maplibregl] = await Promise.all([import("maplibre-gl"), import("maplibre-gl/dist/maplibre-gl.css")]);
  maplibregl.setWorkerUrl(workerUrl);
  return maplibregl;
}
